module.exports = __webpack_public_path__ + "img/sort-default.ed94fc21.svg";